import { useState, useEffect } from 'react'
import MessageHelper from '@utils/messageHelper'
import useT from '@hooks/useTranslation'
import useRedirect from '@hooks/useRedirectBack'

export default function OfferActiveStateGuard ({ offer }) {
    const [redirect] = useRedirect()
    const [redirectPath, setRedirectPath] = useState('')

    const zawieszone = useT('Ogłoszenie jest czasowo zawieszone')

    useEffect(() => {
        if (!redirectPath) {
            const isHanged = offer?.tracking?.hanged

            if (isHanged) {
                MessageHelper.message(zawieszone + '.')
                setRedirectPath('/')
            }
        }
    }, [offer._id])

    return redirectPath
        ? redirect(redirectPath)
        : null
}